import { PHONE_MIN_LENGTH, PHONE_MAX_LENGTH, COUNTRY_CODE_REGEX, DATE_FORMAT_REGEX, MIN_BIRTH_YEAR, VALID_BLOOD_GROUPS, } from "../constants";
export const validatePhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, "");
    return (cleaned.length >= PHONE_MIN_LENGTH && cleaned.length <= PHONE_MAX_LENGTH);
};
export const validateCountryCode = (code) => {
    return COUNTRY_CODE_REGEX.test(code);
};
export const validateBloodGroup = (bloodGroup) => {
    return VALID_BLOOD_GROUPS.includes(bloodGroup);
};
export const validateDateOfBirth = (dob) => {
    if (!dob)
        return false;
    if (!DATE_FORMAT_REGEX.test(dob))
        return false;
    const [yearStr, monthStr, dayStr] = dob.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    if (month < 1 || month > 12 || day < 1 || day > 31)
        return false;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day) {
        return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    if (date > today)
        return false;
    if (year < MIN_BIRTH_YEAR)
        return false;
    return true;
};
export const validateName = (name) => {
    return name.trim().length > 0;
};
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
export const validateSubject = (subject) => {
    return subject.trim().length > 0;
};
export const validateMessage = (message) => {
    return message.trim().length > 0;
};
